import React, { useState } from "react";
import {
  Box,
  Stack,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Typography,
  Divider,
  CircularProgress
} from "@mui/material";

import { loadProductionReportListBJumboNo } from "../../../services/warehouseService";
import { Warehouse_API_ENDPOINTS } from "../../../config/api/apiCallWarehouse";
import { callApi } from "../../../utils/apiClient";
const thickBorder = "2px solid #000";

const JumboNoTrackingReportWithAPI = () => {

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const dummyData = [
    {
      date: "2026-01-26",
      jumbo_no: "26A0001",
      quality: "A",
      gsm: 80,
      jumbo_production: 10,
      jumbo_wip: 3,
      rw_g1: 4.5,
      rw_sl: 1.0,
      rw_buffer: 1.0,
      rw_repulp: 0.5,
      rw_wip: 0,
      reel_g1: 0,
      reel_sl: 0,
      reel_buffer: 0,
      reel_wip: 0,
      sheet_g1: 0,
      sheet_sl: 0,
      sheet_repulp: 0,
      sheet_wip: 0,
      ream_g1: 0,
      ream_sl: 0,
      ream_repulp: 0,
      ream_wip: 0,
      bundle_g1: 0,
      bundle_sl: 0,
      bundle_repulp: 0,
      bundle_wip: 0,
      fin_g1: 0,
      fin_sl: 0,
      fin_repulp: 0,
      fin_wip: 0,
      repulp_jumbo_percent: "5%",
      repulp_rw_percent: "2%"
    }
  ];

  const handleApply = async () => {
  console.log("Apply clicked");
  console.log("From:", fromDate);
  console.log("To:", toDate);

  try {
    setLoading(true);

    const payload = {
      company_id: localStorage.getItem("companyid"),
      from_date: fromDate,
      to_date: toDate
    };

    console.log("Payload:", payload);

    const response = await loadProductionReportListBJumboNo(payload);

    console.log("API Response:", response);

    setTableData(response?.data || []);

  } catch (error) {
    console.error("API Error:", error);
  } finally {
    setLoading(false);
  }
};

  const dataToShow = tableData.length ? tableData : dummyData;

  return (
    <Box p={2}>
      <Typography variant="h5" fontWeight={600} mb={2}>
        Jumbo No Wise Tracking Report
      </Typography>

      <Stack direction="row" spacing={2} mb={2}>
        <TextField
          type="date"
          label="From Date"
          size="small"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          type="date"
          label="To Date"
          size="small"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <Button
          variant="contained"
          color="secondary"
          onClick={handleApply}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : "Apply"}
        </Button>
      </Stack>

      <Divider sx={{ mb: 2 }} />

      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 600,
          border: thickBorder
        }}
      >
        <Table
          size="small"
          stickyHeader
          sx={{ borderCollapse: "collapse" }}
        >
          <TableHead>
            <TableRow>
              <TableCell rowSpan={2} sx={{ border: thickBorder }}><b>Date</b></TableCell>
              <TableCell rowSpan={2} sx={{ border: thickBorder }}><b>Jumbo No</b></TableCell>
              <TableCell rowSpan={2} sx={{ border: thickBorder }}><b>Quality</b></TableCell>
              <TableCell rowSpan={2} sx={{ border: thickBorder }}><b>GSM</b></TableCell>

              <TableCell colSpan={2} align="center" sx={{ bgcolor: "#A5D6A7", border: thickBorder }}>
                <b>Jumbo</b>
              </TableCell>

              <TableCell colSpan={5} align="center" sx={{ bgcolor: "#FFF176", border: thickBorder }}>
                <b>Rewinder</b>
              </TableCell>

              <TableCell colSpan={4} align="center" sx={{ bgcolor: "#C8E6C9", border: thickBorder }}>
                <b>Reel</b>
              </TableCell>

              <TableCell colSpan={4} align="center" sx={{ bgcolor: "#FFE082", border: thickBorder }}>
                <b>Sheet</b>
              </TableCell>

              <TableCell colSpan={4} align="center" sx={{ bgcolor: "#AED581", border: thickBorder }}>
                <b>Ream</b>
              </TableCell>

              <TableCell colSpan={4} align="center" sx={{ bgcolor: "#FFCC80", border: thickBorder }}>
                <b>Bundle</b>
              </TableCell>

              <TableCell colSpan={4} align="center" sx={{ bgcolor: "#B39DDB", border: thickBorder }}>
                <b>Finishing</b>
              </TableCell>

              <TableCell colSpan={2} align="center" sx={{ bgcolor: "#EF9A9A", border: thickBorder }}>
                <b>Repulp %</b>
              </TableCell>
            </TableRow>

            <TableRow>
              {[
                "Production","WIP",
                "G1","SL","Buffer","Repulp","WIP",
                "G1","SL","Buffer","WIP",
                "G1","SL","Repulp","WIP",
                "G1","SL","Repulp","WIP",
                "G1","SL","Repulp","WIP",
                "G1","SL","Repulp","WIP",
                "Jumbo %","Rewinder %"
              ].map((head, i) => (
                <TableCell key={i} sx={{ border: thickBorder }}>
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {dataToShow.map((row, index) => (
              <TableRow key={index}>
                {Object.values(row).map((val, i) => (
                  <TableCell key={i} sx={{ border: thickBorder }}>
                    {val}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>

        </Table>
      </TableContainer>
    </Box>
  );
};

export default JumboNoTrackingReportWithAPI;